<template>
  <div class="text-center">
    <v-dialog v-model="mostradoModal" width="1000" scrollable>
      <v-card>
        <v-card-title v-if="programa" class="text-h6 blue darken-3 white--text font-weight-bold">
          {{ programa.nombre_compuesto }}
        </v-card-title>

        <v-card-text>
          <p class="text-center text-caption my-2">
            La siguiente tabla muestra los modulos del programa y el estado del participante en cada modulo, puede
            cambiar el estado del participante para cada modulo.
          </p>

          <v-row dense>
            <template v-if="persona">
              <v-col cols="12" md="6">
                <b>Estudiante:</b> {{ persona.nombres }} {{ persona.primer_apellido }} {{ persona.segundo_apellido }}
              </v-col>

              <v-col cols="12" md="6"> <b>Documento:</b> {{ persona.numero_documento }} </v-col>

              <v-col cols="12" md="6"> <b>Usuario moodle:</b> {{ persona.usuario_moodle }} </v-col>
            </template>

            <v-col cols="12" md="6" v-if="plataforma"> <b>Moodle:</b> {{ plataforma.direccion }} </v-col>

            <v-col cols="12" md="6" v-if="programa">
              <b>N° de modulos:</b> {{ programa.programa_modulo.length }}
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <p class="text-center text-primary text-caption">
            Haga click en la casilla de estado para cambiar el estado del estudiante en cada modulo, luego debe guardar
            los datos para aplicar los estados asignados.
          </p>

          <v-data-table dense :headers="headers" :items="programasModulos" :items-per-page="30" hide-default-footer>
            <template v-slot:[`item.opciones`]="{ item }">
              <v-simple-checkbox
                v-model="item.checked"
                v-show="!cargandoEstadosCursos"
                :title="item.checked ? 'Suspender' : 'Activar'"
                :disabled="item.course_id == 0 || cargandoEstadosCursos || cambiandoEstadosCursos"
                @input="(event) => agregarACursosParaCambioDeEstado(event, item)" />

              <v-progress-circular
                v-show="cargandoEstadosCursos"
                class="ma-3"
                size="20"
                width="2"
                color="green"
                indeterminate></v-progress-circular>
            </template>

            <template v-slot:[`item.nombre`]="{ item }">
              <div class="pa-0">
                <div class="ma-0">
                  {{ item.nombre }}
                </div>

                <div>
                  <span v-if="item.estaInscrito !== null && item.estaInscrito" class="green--text text-caption">
                    Inscrito en moodle
                  </span>

                  <span v-else-if="item.estaInscrito !== null && !item.estaInscrito" class="red--text text-caption">
                    No inscrito en moodle
                  </span>
                </div>
              </div>
            </template>
          </v-data-table>

          <p class="text-center text-primary text-caption">
            <b>NOTA:</b> el estudiante no visualizará el modulo desmarcado, por lo tanto no podrá acceder al modulo ni
            presentar sus trabajos, esta opcion no modifica los datos de acceso como el usuario y clave del moodle.
          </p>

          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            :disabled="cargandoEstadosCursos || cambiandoEstadosCursos"
            :loading="cambiandoEstadosCursos"
            @click="guardarCambios">
            Guardar
          </v-btn>

          <v-btn color="gray-darken-1" text @click="mostradoModal = false" :disabled="cargandoEstadosCursos">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import xaxios from '@/xaxios';

export default {
  data() {
    return {
      personaId: null,
      programaId: null,
      mostradoModal: false,
      cargando: false,
      persona: null,
      programa: null,
      programasModulos: [],
      plataforma: null,
      cargandoEstadosCursos: false,
      cambiandoEstadosCursos: false,
      msg: '',
      headers: [
        { text: 'Estado', value: 'opciones', sort: false },
        { text: 'Moodle ID', value: 'course_id', sort: false },
        { text: 'N° Módulo', value: 'numero', sort: false },
        { text: 'Nombre del modulo', value: 'nombre', sort: false },
      ],
      cursosIdsParaCambiarEstado: [],
    };
  },
  methods: {
    openmodal(idprograma, idpersona, idins, plataforma) {
      this.programaId = idprograma;
      this.personaId = idpersona;
      this.plataforma = plataforma;

      if (!this.plataforma) {
        this.$root.$notify.show('No se ha encontrado la plataforma moodle', { color: 'red', x: 'right' });

        return;
      }

      this.obtenerEstudianteYProgramaModulos().then(async () => {
        this.mostradoModal = true;

        await this.obtenerEstadosCursos();
      });
    },
    async obtenerEstudianteYProgramaModulos() {
      if (!this.programaId || !this.personaId) {
        return;
      }

      const urlPrograma = `${process.env.VUE_APP_API_REST}/esam/programa/id/${this.programaId}`;
      const urlPersona = `${process.env.VUE_APP_API_REST}/esam/persona/id/${this.personaId}`;

      this.cargando = true;
      this.programa = null;
      this.persona = null;
      this.programasModulos = [];
      this.cursosIdsParaCambiarEstado = [];

      try {
        const responses = await Promise.all([xaxios.get(urlPrograma), xaxios.get(urlPersona)]);

        const [responsePrograma, responsePersona] = responses;

        this.programa = responsePrograma.data;
        this.programasModulos = this.programa.programa_modulo
          .map((programaModulo) => {
            return {
              ...programaModulo,
              estaInscrito: null,
              estaActivo: null,
              checked: null,
            };
          })
          .sort((a, b) => a.numero - b.numero);
        this.persona = responsePersona.data?.persona;
      } catch (error) {
        window.console.error(error);

        if (error.response.status == 403) {
          this.msg =
            'Su sesion ha caducado, lamentamos las molestias causadas, por favor vuelva a ingresar al sistema :)';
        } else {
          this.$root.$notify.show('Error al obtener los datos del estudiante, por favor intente nuevamente.', {
            color: 'red',
            x: 'right',
          });
        }
      } finally {
        this.cargando = false;
      }
    },
    async obtenerEstadosCursos() {
      if (this.programasModulos.length == 0 || !this.plataforma) {
        return;
      }

      const cursosIds = this.programasModulos.map((modulo) => modulo.course_id).filter((id) => id > 0);

      let url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
        this.plataforma.id
      }/user/uname/${this.persona?.usuario_moodle}/gradeitem/grade`;

      url += `?courses=${cursosIds.join(',')}`;

      this.cargandoEstadosCursos = true;

      try {
        const response = await xaxios.get(url);
        const data = response.data;
        const cursos = data.courses || [];

        this.programasModulos = this.programasModulos.map((programaModulo) => {
          const curso = cursos.find((curso) => curso.id == programaModulo.course_id);

          if (curso) {
            return {
              ...programaModulo,
              estaInscrito: curso.estaInscrito,
              estaActivo: curso.estaActivo,
              checked: curso.estaActivo,
            };
          } else {
            return {
              ...programaModulo,
              estaInscrito: false,
              estaActivo: false,
              checked: false,
            };
          }
        });

        this.$root.$notify.show('Estados de los cursos obtenidos correctamente', {
          color: 'green',
          x: 'right',
        });
      } catch (error) {
        window.console.error(error);

        this.$root.$notify.show('Error al obtener los estados de los cursos, por favor intente nuevamente.', {
          color: 'red',
          x: 'right',
        });
      } finally {
        this.cargandoEstadosCursos = false;
      }
    },
    agregarACursosParaCambioDeEstado(event, programaModulo) {
      if (event != programaModulo.estaActivo) {
        this.cursosIdsParaCambiarEstado.push({
          id: programaModulo.course_id,
          estadoDeseado: event,
          estadoActual: programaModulo.estaActivo,
          nombreUsuario: this.persona.usuario_moodle,
        });
      } else {
        const index = this.cursosIdsParaCambiarEstado.findIndex(
          (curso) => curso.id == programaModulo.course_id && curso.estadoActual == programaModulo.estaActivo,
        );

        if (index !== -1) {
          this.cursosIdsParaCambiarEstado.splice(index, 1);
        }
      }
    },
    async guardarCambios() {
      if (this.cursosIdsParaCambiarEstado.length == 0) {
        this.$root.$notify.show('No se han realizado cambios en los estados de los cursos', {
          color: 'orange',
          x: 'right',
        });

        return;
      }

      const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
        this.plataforma.id
      }/enrolment/status`;
      const peticiones = [];

      this.cursosIdsParaCambiarEstado.forEach((curso) => {
        const peticion = xaxios.post(url, {
          course_id: curso.id,
          current_status: curso.estadoActual,
          desired_status: curso.estadoDeseado,
          username: curso.nombreUsuario,
        });

        peticiones.push(peticion);
      });

      this.cambiandoEstadosCursos = true;

      try {
        await Promise.all(peticiones);

        this.$root.$notify.show('Los estados de los cursos han sido actualizados correctamente', {
          color: 'green',
          x: 'right',
        });

        this.obtenerEstadosCursos().then(() => {
          this.cursosIdsParaCambiarEstado = [];
        });
      } catch (error) {
        window.console.error(error);

        this.$root.$notify.show('Error al actualizar los estados de los cursos, por favor intente nuevamente.', {
          color: 'red',
          x: 'right',
        });
      } finally {
        this.cambiandoEstadosCursos = false;
      }
    },
  },
};
</script>
